import React from "react";
import PropTypes from "prop-types";
import { Store } from "../../flux";
import {inject, observer} from "mobx-react";
import {action, observable} from "mobx";
import {
  Button,
  Col, FormSelect, Row,
} from "shards-react";
import moment from "moment";

import './Header.scss'
import {Link, withRouter} from "react-router-dom"
import imgBrand from "../../images/avatars/brand_60.png";
import {toast} from "react-toastify";
import {reactLocalStorage as Storage} from "reactjs-localstorage";


@inject(({ common }) => ({ getCurNav: common.getCurNav, favorites: common.favorites, toggleFavorite: common.toggleFavorite, reorderFavorites: common.reorderFavorites }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, doLogOut:teamUser.doLogOut, updateTeamUser:teamUser.updateTeamUser }))
@inject(({ company }) => ({ getApplyShop:company.getApplyShop, updateStore:company.updateStore }))

@observer
class Header extends React.Component {

  @observable store = {};
  @observable teamUser = {};
  @observable shops = [];
  @observable emailId = '';
  @observable isLogin = false;
  @observable isShowSetting = false;

  // 즐겨찾기 드래그&드롭 상태
  @observable favDragIndex = null;
  @observable favOverIndex = null;

  @action onFavDragStart = (e, idx) => {
    this.favDragIndex = idx;
    if (e && e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'move';
      try { e.dataTransfer.setData('text/plain', String(idx)); } catch(err) {}
    }
  };

  @action onFavDragOver = (e, idx) => {
    if (e) {
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
    }
    if (this.favOverIndex !== idx) this.favOverIndex = idx;
  };

  @action onFavDragLeave = (idx) => {
    if (this.favOverIndex === idx) this.favOverIndex = null;
  };

  @action onFavDrop = (e, toIdx) => {
    if (e) e.preventDefault();
    let fromIdx = this.favDragIndex;
    if (fromIdx == null && e && e.dataTransfer) {
      const txt = e.dataTransfer.getData('text/plain');
      if (txt !== '') fromIdx = parseInt(txt, 10);
    }
    if (fromIdx != null && fromIdx !== toIdx && this.props.reorderFavorites) {
      this.props.reorderFavorites(fromIdx, toIdx);
    }
    this.favDragIndex = null;
    this.favOverIndex = null;
  };

  @action onFavDragEnd = () => {
    this.favDragIndex = null;
    this.favOverIndex = null;
  };

  // 즐겨찾기 항목 1개 렌더링 (인라인 / 더보기 드롭다운 / 모바일 드롭다운 공통)
  // idx 는 전체 favorites 배열 기준 인덱스 (드래그 정렬·활성 표시에 사용)
  renderFavItem = (fav, idx) => {
    const isDragging = this.favDragIndex === idx;
    const isOver = this.favOverIndex === idx && this.favDragIndex !== idx;
    // 현재 URL 과 일치하면 활성 표시
    const currentPath = (this.props.location && this.props.location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '');
    const isActiveFav = fav.to && currentPath === fav.to;
    const itemClass = (isDragging ? 'fav-dragging ' : '') + (isOver ? 'fav-drag-over ' : '') + (isActiveFav ? 'fav-active' : '');
    return (
      <li
        key={fav.to || idx}
        className={itemClass.trim()}
        draggable={true}
        onDragStart={(e) => this.onFavDragStart(e, idx)}
        onDragOver={(e) => this.onFavDragOver(e, idx)}
        onDragLeave={() => this.onFavDragLeave(idx)}
        onDrop={(e) => this.onFavDrop(e, idx)}
        onDragEnd={() => this.onFavDragEnd()}
        title="드래그하여 순서 변경"
        style={{cursor: 'grab'}}
      >
        <Link to={fav.to} draggable={false}>
          <i className="material-icons" draggable={false}>{fav.mIcon}</i>
          <span draggable={false}>{fav.label}</span>
        </Link>
        <span className="fav-remove" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.props.toggleFavorite(fav); }}>
          <i className="material-icons">close</i>
        </span>
      </li>
    );
  };

  constructor(props) {
    super(props);
    this.init();
    this.onChange = this.onChange.bind(this);
  }

  @action
  init = async (key) => {

    this.state = {
      menuVisible: false,
      sidebarNavItems: Store.getSidebarItems()
    };

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.emailId = this.props.me.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.store.replyCount = this.props.me.replyCount ? this.props.me.replyCount : {};
      if(this.store.replyCount.writeCount === undefined) {
        this.store.replyCount.writeCount = 0;
      }
      this.getApplyShops(false);
    }

  };

  getApplyShops = async (actSync) => {
    let _this = this;
    let shops = await Storage.getObject('shops');
    if(shops.length > 0){
      _this.shops = shops;
    }
    else {
      let updateStore = {
        store_id: this.teamUser.store._id
      }
      this.props.getApplyShop( updateStore, function(res) {
        if(res.errors && res.errors.length > 0) {
          toast(res.errors[0].message);
        }
        else {
          Storage.setObject('shops', res.data);
          _this.shops = res.data;
          if(actSync) {
            toast('업데이트가 완료 되었습니다.');
          }
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState){

  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      ...this.state,
      menuVisible: Store.getMenuState(),
      sidebarNavItems: Store.getSidebarItems()
    });
  }

  onChangeShop = async (event) => {
    const { value } = event.target;
    let shopNo = value ? parseInt(value) : 1;
    this.teamUser.selShopNo = shopNo;

    let updateStore = {
      id: this.teamUser._id,
      selShopNo: shopNo,
    }

    this.props.updateTeamUser( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        window.location.reload();
      }
    });


    //todo 주문수 가져오기
    //todo shopNo 변경
    //todo 주문시 shopNo
    // this.orderInfo[name] = value;
  };


  render() {

    const MAX_INLINE = 5;
    const favs = this.props.favorites || [];

    return (
      <div className="header">
        <button type="button"
                className="header-mobile-toggle"
                aria-label="메뉴 열기"
                onClick={() => window.dispatchEvent(new CustomEvent('sidebar-mobile-toggle'))}>
          <i className="material-icons">menu</i>
        </button>
        <div className="top-favorites">
          <div className="favorites-toggle">
            <i className="material-icons favorites-icon">star</i>
            <span className="favorites-label">즐겨찾기</span>
          </div>
          {favs.length > 0 ? (
            <>
              <ul className="favorites-inline">
                {favs.slice(0, MAX_INLINE).map((fav, idx) => this.renderFavItem(fav, idx))}
                {favs.length > MAX_INLINE ? (
                  <li className="favorites-more" title="즐겨찾기 더보기">
                    <button type="button" className="favorites-more__btn" aria-label="즐겨찾기 더보기">
                      <span className="favorites-more__label">
                        {favs.length - MAX_INLINE - 1 > 0
                          ? `${favs[MAX_INLINE].label} 외 ${favs.length - MAX_INLINE - 1}`
                          : favs[MAX_INLINE].label}
                      </span>
                    </button>
                    <ul className="favorites-more-dropdown">
                      {favs.slice(MAX_INLINE).map((fav, i) => this.renderFavItem(fav, i + MAX_INLINE))}
                    </ul>
                  </li>
                ) : null}
              </ul>
              <ul className="favorites-dropdown">
                {favs.map((fav, idx) => this.renderFavItem(fav, idx))}
              </ul>
            </>
          ) : (
            <>
              <div className="favorites-empty-inline">
                <span>사이드 메뉴에서 ☆ 을 클릭하여 추가</span>
              </div>
              <ul className="favorites-dropdown">
                <li className="empty-msg">사이드 메뉴에서 별 아이콘을 클릭하여 즐겨찾기를 추가하세요.</li>
              </ul>
            </>
          )}
        </div>
        <div className="top-gnb">
          <div className="top-notice">
            <span className="notice-icon"><i data-feather="volume" className="nd-icon"></i></span>
            {
              !this.store.isUseFirstOrder ? (
                  <span className="notice-content"><Link to="/inAppOrder" className="text-red">이벤트를 놓치지 마세요!</Link></span>
              ) : this.teamUser.selShopExpiryDate && moment(this.teamUser.selShopExpiryDate) < moment() ? (
                  <span className="notice-content"><Link to="/inAppOrder" className="text-red">사용 기간이 지났습니다. 리뷰위젯 및 기능이 제한 됩니다.</Link></span>
              ) : !this.teamUser.selShopExpiryDate ? (
                  <span className="notice-content"><Link to="/inAppOrder" className="text-red">서비스 신청하기</Link></span>
              ) : null
            }

          </div>
          {/* 현재 접속된 쇼핑몰명 — shop select 좌측에 노출 (도메인은 title 툴팁) */}
          {this.store && this.store.name ? (
            <div className="top-tool top-tool--hide-mobile top-tool--store-name"
                 title={this.store.domain || ''}
                 style={{display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, color: '#374151', maxWidth: 200, overflow: 'hidden'}}>
              <i className="material-icons" style={{fontSize: 16, color: '#6B7280'}}>storefront</i>
              <span style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{this.store.name}</span>
            </div>
          ) : null}
          <div className="top-tool top-tool--hide-mobile">
            <FormSelect value={this.teamUser.selShopNo} name="shopNo"
                        onChange={event => {
                          this.onChangeShop(event)
                        }}
            >
              {this.shops.map((item, i) => {
                return (<option key={i} i={i} value={item.platformShopNo}>{item.shopName}</option>);
              })}
            </FormSelect>
          </div>
          {/* 수정 5-2: 각 아이콘 툴팁 (data-tooltip). 모바일에선 설정 메뉴로 통합 */}
          <div className="top-tool top-tool--tip top-tool--hide-mobile" data-tooltip="쉬운설치">
            <a href="/easySetting"><i className="material-icons">rocket_launch</i></a>
          </div>
          <div className="top-tool top-tool--tip top-tool--hide-mobile" data-tooltip="매뉴얼">
            <a href="https://onnomad.co.kr/manual" target="_blank" rel="noopener noreferrer"><i className="material-icons">import_contacts</i></a>
          </div>
          {/* 수정 5-1: 상담 채팅 복원 — 시간 제약 제거, 항상 노출 */}
          <div className="top-tool top-tool--tip top-tool--hide-mobile" data-tooltip="상담 채팅">
            <button type="button" className="top-tool__btn-link" onClick={(e) => {
              e.preventDefault();
              if (this.props.onChatOpen) this.props.onChatOpen(e);
            }}><i className="material-icons">chat</i></button>
          </div>
          <div className="top-tool top-tool--tip" data-tooltip="설정"
               onClick={event => { this.isShowSetting = !this.isShowSetting; }}>
            <i className="material-icons">settings</i>
          </div>
          {/* 수정 5-3: 로그아웃 좌측 세로 구분선 (모바일 숨김) */}
          <span className="top-tool__sep top-tool--hide-mobile" aria-hidden="true"></span>
          <Link to={(this.isLogin && this.emailId) ? "/signIn?logout=1" : "/signIn"} className="top-user top-tool--tip top-tool--hide-mobile"
                data-tooltip={(this.isLogin && this.emailId) ? '로그아웃' : '로그인'}>
            {(this.isLogin && this.emailId) ?
                <i className="material-icons">logout</i>
                :
                <i className="material-icons">login</i>
            }
          </Link>



        </div>
        {this.isShowSetting ? (
            <div className="setting-box">
              <ul>
                <li className="store-info">
                  <Row>
                    <Col md="4">
                      <span className="brand-thumb"><img src={imgBrand} alt={this.store.name}/></span>
                    </Col>
                    <Col>
                      <p className="store-name">{this.store.name}</p>
                      <p className="store-id">{this.store.domain}</p>
                    </Col>
                  </Row>
                </li>
                <li className="service-info">
                  <div>
                    <h6 style={{marginBottom: 6, fontSize: 12, color: '#6B7280'}}>샵 선택</h6>
                    <FormSelect value={this.teamUser.selShopNo} name="shopNo"
                                onChange={event => {
                                  this.onChangeShop(event);
                                  this.isShowSetting = false;
                                }}
                    >
                      {this.shops.map((item, i) => {
                        return (<option key={i} i={i} value={item.platformShopNo}>{item.shopName}</option>);
                      })}
                    </FormSelect>
                  </div>
                </li>
                <li className="service-info">
                  <div>
                    <h6>서비스 이용 현황</h6>
                    {this.store.isPaidUser && this.store.useExpiryDate ? (
                        <ul>
                          <li><span>만료일 : {moment(this.store.useExpiryDate).format('YYYY-MM-DD')}</span></li>
                        </ul>
                    ) : null}
                    <div className="text-center mt-3">
                      <Link to="/inAppOrder" onClick={() => this.isShowSetting = false}><Button theme="light" size="sm">서비스 주문하기</Button></Link>
                    </div>
                  </div>
                </li>
                <li><Link to="/inAppOrderList" onClick={() => this.isShowSetting = false}>결제내역 및 이용내역</Link></li>
                <li><Link to="/easySetting" onClick={() => this.isShowSetting = false}>
                  <i className="material-icons" style={{fontSize: 16, verticalAlign: '-3px', marginRight: 6, color: '#5664D2'}}>rocket_launch</i>
                  쉬운설치
                </Link></li>
                <li><a href="https://onnomad.co.kr/manual" target="_blank" rel="noopener noreferrer" onClick={() => this.isShowSetting = false}>
                  <i className="material-icons" style={{fontSize: 16, verticalAlign: '-3px', marginRight: 6, color: '#5664D2'}}>import_contacts</i>
                  매뉴얼
                </a></li>
                <li><button type="button" className="setting-box__link-btn" onClick={(e) => {
                  e.preventDefault();
                  this.isShowSetting = false;
                  if (this.props.onChatOpen) this.props.onChatOpen(e);
                }}>
                  <i className="material-icons" style={{fontSize: 16, verticalAlign: '-3px', marginRight: 6, color: '#5664D2'}}>chat</i>
                  상담 채팅
                </button></li>
                <li><Link to="/reviewWriteConfig" onClick={() => this.isShowSetting = false}>설정</Link></li>
                <li className="logout-item">
                  <Link to={(this.isLogin && this.emailId) ? "/signIn?logout=1" : "/signIn"} onClick={() => this.isShowSetting = false}>
                    <i className="material-icons" style={{fontSize: 16, verticalAlign: '-3px', marginRight: 6, color: '#DC2626'}}>logout</i>
                    {(this.isLogin && this.emailId) ? '로그아웃' : '로그인'}
                  </Link>
                </li>
              </ul>
            </div>
        ) : null}

      </div>
    );
  }
}

Header.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

Header.defaultProps = {
  hideLogoText: false
};

export default withRouter(Header);
